export default __webpack_public_path__ + "static/sweepstakes-second-1-233d44fefeb7e07a68052356127876aa.jpg";